import { SchoolEducationalDetails } from './school-educational-details';

export class School {
  schoolId?: number;
  status: boolean = true;
  arabicName: string;
  englishName: string;
  companyId?: number;
  countryId: number;
  cityId: number;
  area: string;
  email: string;
  phone: string;
  mobile: string;
  address: string;
  website: string;
  numberOfStudent: number;
  fax: string;
  lat: string;
  lng: string;
  languageId: number;
  timeZone: string;
  faceBookUrl: string;
  twitterUrl: string;
  linkedInUrl: string;
  instagramUrl: string;
  googlePlusUrl: string;
  snapChatUrl: string;
  pinterestUrl: string;
  schoolEducationalDetails: SchoolEducationalDetails[] = [];
  companyName: string;
  companyNameEn: string;
}
